// @generated-imports
import { escapeAttribute, escapeHTML, findGameById, playGame, truncate } from './app.js';
import { dom, state } from './core.js';
import { localRomAsGame } from './library.js';
import { describeSlot, getStateRecord, latestStateMeta } from './states.js';
// @generated-imports
/* ===========================================================================
   "CONTINUE DE ONDE PAROU" (v2.1)
   ---------------------------------------------------------------------------
   Usa o índice leve de estados (states.js → state.stateMeta): miniatura,
   slot e horário do último ponto de cada jogo. Alimenta a fileira acima do
   catálogo e a miniatura no botão Continuar.
   ======================================================================== */

function relativeTime(ts, now = Date.now()) {
  const diff = Math.max(0, now - ts);
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return 'agora mesmo';
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `há ${hours} h`;
  const days = Math.floor(hours / 24);
  if (days === 1) return 'ontem';
  if (days < 30) return `há ${days} dias`;
  return `em ${new Date(ts).toLocaleDateString('pt-BR')}`;
}

function resumeCandidates(limit = 3) {
  if (!state.stateMeta || !state.stateMeta.size) return [];
  return [...state.stateMeta.values()]
    .map((meta) => ({ meta, game: findGameById(meta.gameId) || (state.localRoms.has(meta.gameId) ? localRomAsGame(state.localRoms.get(meta.gameId)) : null) }))
    .filter((entry) => entry.game)
    .sort((a, b) => (b.meta.savedAt || 0) - (a.meta.savedAt || 0))
    .slice(0, limit);
}

function renderResumeRow() {
  if (!dom.resumeRow || !dom.resumeCards) return;
  const entries = resumeCandidates(3);
  dom.resumeRow.classList.toggle('is-hidden', !entries.length);
  dom.resumeCards.innerHTML = entries.map(({ meta, game }) => `<button class="resume-card" type="button" data-resume-state="${escapeAttribute(meta.stateId)}" data-resume-game="${escapeAttribute(game.id)}" title="Retomar ${escapeAttribute(game.title)} do ${escapeAttribute(describeSlot(meta.slot))}">
      ${meta.thumbnail ? `<img class="resume-thumb" src="${meta.thumbnail}" alt="">` : `<span class="resume-thumb resume-thumb-empty" aria-hidden="true">▶</span>`}
      <span class="resume-info"><strong>${escapeHTML(truncate(game.title, 28))}</strong>
        <small>${escapeHTML(relativeTime(meta.savedAt))} · ${escapeHTML(describeSlot(meta.slot))}</small></span>
    </button>`).join('');
}

async function handleResumeClick(event) {
  const card = event.target.closest('[data-resume-state]');
  if (!card) return;
  const gameId = card.dataset.resumeGame;
  const game = findGameById(gameId) || (state.localRoms.has(gameId) ? localRomAsGame(state.localRoms.get(gameId)) : null);
  if (!game) return;
  const record = await getStateRecord(card.dataset.resumeState).catch(() => null);
  playGame(game, record ? { resumeRecord: record } : {});
}

/** Miniatura + "parou há X" para o botão Continuar (ou null). */
function continueResumeInfo(gameId) {
  const meta = latestStateMeta(gameId);
  if (!meta) return null;
  return { thumbnail: meta.thumbnail, when: relativeTime(meta.savedAt), slot: describeSlot(meta.slot) };
}

// @generated-exports
export { continueResumeInfo, handleResumeClick, relativeTime, renderResumeRow, resumeCandidates };
// @generated-exports
